var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.580874 0.993257C0.672258 0.640953 0.832059 0.373196 1.02524 0.248692C1.21842 0.124188 1.42921 0.153098 1.6114 0.329084L10.497 8.92758L19.3811 0.326106C19.4715 0.236699 19.5701 0.182819 19.6713 0.167574C19.7725 0.152328 19.8742 0.176017 19.9707 0.237276C20.0671 0.298536 20.1563 0.396152 20.2332 0.524499C20.31 0.652847 20.373 0.809386 20.4185 0.985091C20.464 1.1608 20.491 1.35219 20.4981 1.54824C20.5052 1.74429 20.4922 1.94112 20.4598 2.12738C20.4274 2.31365 20.3763 2.48565 20.3094 2.63349C20.2426 2.78132 20.1612 2.90207 20.0702 2.98875L10.8415 11.9238C10.7346 12.0276 10.6166 12.0816 10.497 12.0816C10.3774 12.0816 10.2594 12.0276 10.1525 11.9238L0.923871 2.98875C0.741932 2.8118 0.603654 2.50236 0.539357 2.12829C0.47506 1.75422 0.48999 1.34604 0.580874 0.993257Z",
    fill: "#ADB5BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.c2ee35bfa76766b3b022abbc77237707.svg";
export { ForwardRef as ReactComponent };